import React from 'react';

// components
import Input from '../../components/general/Input';

const CreditCheck = props => {
  return (
    <div class="relative">
      <div class="relative px-4 sm:px-6 lg:px-8">
        <div class="pt-8 pb-16">
          <p class="pt-6 font-medium max-w-screen-md mx-auto text-center">
            Not to get all up in your business, but we have to check one last thing. P.S. this will
            not affect your credit.
          </p>
          <div class="pt-8 max-w-5xl mx-auto ">
            <form
              onSubmit={e => e.preventDefault()}
              class="mt-9 grid grid-cols-1 gap-y-6 sm:grid-cols-4 sm:gap-x-8"
            >
              <div class="sm:col-span-2">
                <div for="email" class="block text-sm font-bold leading-5 text-pink-500">
                  Social Security #
                </div>
                <div class="mt-1 relative rounded-md shadow-sm">
                  <Input
                    onChange={e => props.handleChange('SSN', e.target.value)}
                    id="social"
                    type="password"
                    placeholder="1234-56-7890"
                    value={props.SSN}
                    className="py-4 form-input block w-full transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                    error={props.errors.SSN}
                  />
                </div>
              </div>
              <div class="">
                <div for="service-address" class="block text-sm font-bold leading-5 text-gray-700">
                  Day of Birth
                </div>
                <div class="mt-1 relative rounded-md shadow-sm">
                  <Input
                    onChange={e => props.handleChange('dateOfBirth', e.target.value)}
                    type="date"
                    placeholder="mm/dd/yyyy"
                    className="py-4 form-input block w-full transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                    value={props.dateOfBirth}
                    error={props.errors.dateOfBirth}
                  />
                </div>
              </div>

              <div class="mt-6">
                <span class="rounded-md">
                  <button
                    onClick={props.runCreditCheck}
                    type="submit"
                    className="inline-flex justify-center py-4 px-12 text-sm leading-5 font-bold rounded-md text-white bg-green-400 hover:bg-yellow hover:text-gray-900 focus:outline-none focus:border-white focus:shadow-outline-black active:bg-black transition duration-150 ease-in-out"
                  >
                    Credit Check
                    <svg
                      class="ml-3 -mr-1 h-5 w-5"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <path d="M24 12c0-6.627-5.373-12-12-12s-12 5.373-12 12 5.373 12 12 12 12-5.373 12-12zm-18.005-1.568l1.415-1.414 4.59 4.574 4.579-4.574 1.416 1.414-5.995 5.988-6.005-5.988z" />
                    </svg>
                  </button>
                </span>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreditCheck;
